const formCSSRules = [
  `
    #form-container-ref{
    --form-field-border-radius: 0px;
    --inline-container-max-width: 75%;
    --button-border-radius: 0px;
    --form-field-padding: 5px;
    --form-field-padding-top: 0px;
    --form-field-padding-bottom: 0px;
    --button-padding: 10px;
    }`,
  ` #form-container-ref * {
        font-family: var(--bs-body-font-family);

    }`,
  `section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"]:not([aria-label="Successfully Signed Up"]){
    --col-size: 400px;
    height: 500px;
    }`,
  `section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"] > div{
    display: flex;
    flex-direction: column;
    align-items: center;
     justify-content: center;
    }`,
  `section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"] section{
   height: fit-content;
   flex: 0;
    }`,
  `#form-container-ref form{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 60px;
    }`,
  `#form-container-ref div > input{
    height: 40px;
    font-size: 12px;

}`,
  `#form-container-ref div > input::placeholder{
   color: black;
}`,
  `#form-container-ref div > label{
    position: absolute;
    top: 50% !important;
    left: 5px;
    transform: translateY(-50%);
    text-transform: uppercase;
        font-size: 12px;
        

}`,
  `#form-container-ref div > input:focus + label,
  #form-container-ref div > label._inputFilled_1mxsl_74{
display: none;
}`,
  ` #form-container-ref div:has(> input:not([type="submit"])){
     width: 100%;
    }
`,
  `
    #form-container-ref div:has(> #last_name),
    #form-container-ref div:has(> #first_name){
    flex-grow: 1;
    flex-basis: 0;
    }
`,
  ` #form-container-ref button{
  margin-top: 5px;
  height: 20px;
width: 100%;
line-height: 18px;
}`,
  ` #form-container-ref h2,
   #form-container-ref p{
  color: var(--darker-secondary-rgba);    
}   `,
  ` #form-container-ref h2{
    font-size: 18px;
    margin-bottom: 5px;}`,
  `#form-container-ref p{
   font-family: var(--fancy-font-family);
   font-weight: bold;`,
];

function injectStylesIntoFormShadowRootForm() {
  const observer = new MutationObserver((mutation, observer) => {
    const form = document.querySelector(`#app-embed`);
    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;
      const sheet = new CSSStyleSheet();
      formCSSRules.forEach((formCSS) => {
        sheet.insertRule(formCSS);
      });
      shadow.adoptedStyleSheets.push(sheet);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function injectStylesIntoFormDialogShadowRoot() {
  const observer = new MutationObserver((mutation, observer) => {
    let form = document.querySelector(`#app-embed-container-902788`);
    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;
      const sheet = new CSSStyleSheet();
      formCSSRules.forEach((formCSS) => {
        sheet.insertRule(formCSS);
      });
      shadow.adoptedStyleSheets.push(sheet);

      const mediaSheet = new CSSStyleSheet({ media: "(max-width: 749px)" });
      mediaSheet.replaceSync(`
        section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"] > div:first-child{
          display: none;
          height: 0px;
          
          }
           section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"] > div:nth-child(2){
          height: 100%;
          
          }
            section[aria-modal="true"] section[data-sizing="form-wrapper"][role="dialog"]{
          display: flex;
          flex-direction: column;
          align-items: center;
          }
            `);

      shadow.adoptedStyleSheets.push(mediaSheet);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener("load", () => {
  injectStylesIntoFormShadowRootForm();
  injectStylesIntoFormDialogShadowRoot();
});
